import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";
import { ModernStatWidget } from "../../Components/DashboardCard";

function RequestSales() {
  const { data } = UseGetDashBoardData(`/dashboard/purchaseRequest`);
  const percentage = parseFloat(data?.selected_month_count) || 0;
  const isNegative = percentage < 0;

  const RequestIcon = (
    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
    </svg>
  );

  return (
    <ModernStatWidget
      title="Customer YPR"
      value={data?.total_count || 0}
      percentage={percentage}
      isNegative={isNegative}
      icon={RequestIcon}
      bgColor="bg-amber-500/10"
      iconColor="text-amber-600"
      badgeLabel="this month"
    />
  );
}

export default RequestSales;